import { Component, OnInit, HostBinding, Input, ViewChild, ElementRef, Host } from '@angular/core';
@Component({
  selector: 'f-file-view-image',
  templateUrl: './f-file-view-image.component.html',
  styleUrls: ['./f-file-view-image.component.css']
})
export class FFileViewImageComponent implements OnInit {
  @Input() maxHeight = 200;
  @Input() maxWidth = 300;
  @HostBinding('class.f-file-view-image') cls = true;
  @HostBinding('style.height') selfHeight='50px';
  @ViewChild('canvas') canvas: ElementRef;
  private tFile: File;
  @Input()
  set file(fileContent: File) {
    this.tFile = fileContent;
    this.createImageByCanvas();
  }
  get file(): File {
    return this.tFile;
  }

  constructor() { }

  ngOnInit() {
  }
  private changeImageSize(originWidth,originHeight) {

    // 图片原始尺寸

    // 目标尺寸
    var targetWidth = originWidth, targetHeight = originHeight;
    // 图片尺寸超过400x400的限制
    if (originWidth > this.maxWidth || originHeight > this.maxHeight) {
      if (originWidth / originHeight > this.maxWidth / this.maxHeight) {
        // 更宽，按照宽度限定尺寸
        targetWidth = this.maxWidth;
        targetHeight = Math.round(this.maxWidth * (originHeight / originWidth));
      } else {
        targetHeight = this.maxHeight;
        targetWidth = Math.round(this.maxHeight * (originWidth / originHeight));
      }
    }
    this.selfHeight=targetHeight+"px";
    return {
      width: targetWidth,
      height: targetHeight
    }
  }
  // 压缩图片需要的一些元素和对象

  private createImageByCanvas() {
    let reader = new FileReader();
    let tImage = new Image();
    let canvas = this.canvas.nativeElement;
    let context = canvas.getContext('2d');
    // base64地址图片加载完毕后
    tImage.onload = () => {
      let imgSize = this.changeImageSize(tImage.width,tImage.height);
      // canvas对图片进行缩放
      canvas.width = imgSize.width;
      canvas.height = imgSize.height;
      // 清除画布
      context.clearRect(0, 0,this.maxWidth,this.maxHeight);
      // 图片压缩
      context.drawImage(tImage, 0, 0, imgSize.width, imgSize.height);
    };

    // 文件base64化，以便获知图片原始尺寸
    reader.onload =(ev)=>{
      tImage.src = reader.result as string;
    };
    reader.onerror = function (e) {
    }
    reader.readAsDataURL(this.file);
  }












}
